import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useListView} from './about-details/core/ListViewProvider'
import {ID, isNotEmpty, KTCard, KTCardBody, QUERIES} from '../../../_dashboard/helpers'
import {useQuery} from 'react-query'
import {getOneById} from '../../services/common_requests'
import {useFormik} from 'formik'
import _ from 'lodash'
import ReactQuill from 'react-quill'
import ImageEditModal from '../hotel-management/hotel-details/image-edit-modal/ImageEditModal'
import {images} from '../hotel-management/hotel-details/core/_models'
import {useIntl} from 'react-intl'
import ImageUploader from '../../../_dashboard/partials/widgets/upload/ImageUploader'
import SectionOne from '../../../_dashboard/partials/components/communSections/SectionOne'
import {Formik, Form} from 'formik'
import SectionTwo from '../../../_dashboard/partials/components/communSections/SectionTwo'


const About: React.FC = () => {
  const intl = useIntl()
  const validationSchema = Yup.object().shape({})
  const [selectedImage, setSelectedImage] = useState<images | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleImageClick = (img: images) => {
    setSelectedImage(img)
    setIsModalOpen(true)
  }
  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedImage(null)
  }
  const handleUpdateImage = (updatedImage: {url: string; seoUrl?: string}) => {
    if (typeof formik.values.image === 'string') {
      formik.setFieldValue('image', updatedImage.url)
    }
    if (updatedImage.seoUrl) {
      formik.setFieldValue('seoUrl', updatedImage.seoUrl)
    }
    handleCloseModal()
  }

  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: About,
    error,
  } = useQuery(
    `${QUERIES.ABOUT_PAGE}-About-${itemIdForUpdate}`,
    () => {
      if (!itemIdForUpdate) {
        throw new Error('ID is undefined')
      }
      return getOneById(itemIdForUpdate, '/About')
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  const initialValues = About
    ? {
        id: About._id,
        description: About.description,
        Title: About.Title,
        SubTitle: About.SubTitle,
        image: About.image,
        yearsExperience: About.yearsExperience,
        satisfaction: About.satisfaction,
        services: About.services,
        clients: About.clients,
        seoUrl: About.seoUrl,
        Button: About.Button,
      }
    : {
        id: '',
        description: 'L évasion parfaite, luxe et détente au cœur du paradis !...',
        image:
          'https://xml.beachhotelsresorts.tn/file_manager/source/Iris Djerba Thalasso/AnyConv-com__HBG00173-HDR (1).webp',
        email: '',
        services: '',
        seoUrl: 'About-alt',
        Button: 'Book Now',
      }
  const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
      const modifiedFields = Object.keys(values).reduce((acc, key) => {
        const typedKey = key as keyof typeof values
        if (!_.isEqual(values[typedKey], initialValues[typedKey])) {
          acc[typedKey] = values[typedKey]
        }
        return acc
      }, {} as Record<string, any>)

      try {
        const response = await fetch('https://your-api-endpoint.com/upload', {
          method: 'POST',
        })

        if (!response.ok) {
          throw new Error('Network response was not ok')
        }

        await response.json()
      } catch (error) {
        console.error('Error:', error)
      }
    },
  })
  useEffect(() => {
    if (About) {
      formik.setValues({
        id: About._id,
        description: About.description,
        Title: About.Title,
        SubTitle: About.SubTitle,
        image: About.image,
        yearsExperience: About.yearsExperience,
        satisfaction: About.satisfaction,
        services: About.services,
        clients: About.clients,
        seoUrl: About.seoUrl,
        Button: About.Button,
      })
    }
  }, [About])
  const image =
    'https://admin.mygo.co/file_manager/source/photos/tunisie/Djerba/Hari%20Club%20Beach%20Resort/Hari_Club_Beach_Resort_Djerba_3.jpg'

  return (
    <KTCard>
      <KTCardBody className='py-4'>
        <div className='py-4 app-content flex-column-fluid'>
          <div className='row'>
            <div className='col-md-12'>
              <h3 className='mb-6'>{intl.formatMessage({id: 'About.TITLE'})}</h3>

              {/* Section One */}
              <div className='form-group mb-4'>
                <label className='me-3 mb-3'>
                  <strong>{intl.formatMessage({id: 'COMMUN.SECTION_ONE'})}</strong>
                </label>
                <Formik
                  initialValues={initialValues}
                  onSubmit={() => undefined}
                >
                  <Form>
                    <SectionOne
                      image={initialValues.image}
                      isModalOpen={isModalOpen}
                      selectedImage={selectedImage}
                      handleImageClick={handleImageClick}
                      handleCloseModal={handleCloseModal}
                      handleUpdateImage={handleUpdateImage}
                    />
                  </Form>
                </Formik>
              </div>

              {/* Section Two */}
              <div className='form-group mb-4'>
                <label className='me-3 mb-3'>
                  <strong>{intl.formatMessage({id: 'COMMUN.SECTION2'})}</strong>
                </label>
                <Formik
                  initialValues={initialValues}
                  onSubmit={() => undefined}
                >
                  <Form>
                    <SectionTwo
                      image={image}
                      handleImageClick={() => handleImageClick({ 
                        _id: formik.values.id as unknown as ID,
                        url: image || formik.values.image, 
                        seoUrl: formik.values.seoUrl 
                      })}
                    />
                  </Form>
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </KTCardBody>
    </KTCard>
  )
}

export {About}
